/**
 * Composable for branding-related utilities
 * Provides methods to customize text with installation-specific branding
 */
import { applyBrandingToText } from 'shared/helpers/brandingText';

export function useBranding() {
  /**
   * Replaces "Chatwoot" and chatwoot.com URLs with installation branding
   * @param {string} text - The text to process
   * @returns {string} - Branded text
   */
  const replaceInstallationName = text => applyBrandingToText(text);

  return {
    replaceInstallationName,
  };
}
